import { createContext } from 'react'
import type { ResolvedConfigFeature, ResolveConfigRouteInput } from './configDefinition'

export type ConfigRouteResolver = (input: ResolveConfigRouteInput) => ResolvedConfigFeature

export const ConfigRouteResolverContext = createContext<ConfigRouteResolver | null>(null)
